export default __webpack_public_path__ + "static/media/kiser.dbec22b7.png";